export const selectStylesNetcore = {
  control: (base, state) => ({
    ...base,
    // borderRadius: "15px",
    // width: "203px",
    height: "32px",
    display: "flex",
    outline: "none",
    border: state.isFocused ? "1px solid black" : "1px solid black",
    minWidth: "334px",
    boxShadow: "0 !important",
    "&:hover": {
      border: "1px solid black !important",
    },
  }),
  option: (base, state) => ({
    ...base,
    background: "none",
    color: state.isSelected ? "black" : "black",
    opacity: state.isDisabled ? "0.5" : 1,
    ":active": {
      background: "#fff",
    },
  }),
};
export const breadcrumb = [
  { label: "home", url: "/cms" },
  { label: "user contact push", url: "/cms/user-contact-push" },
];
